export default {
  viewBox: "0 0 17 16",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 1.5h3.5a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-1 0V3.207l-8.146 8.147a.5.5 0 0 1-.708-.708L13.293 2.5H11a.5.5 0 0 1 0-1m-7 3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V7a.5.5 0 0 1 1 0v5.5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h5.5a.5.5 0 0 1 0 1z\" clip-rule=\"evenodd\"/>"
};